import { ActionTypes } from "../constants";
import bse from "../reducers/bse";

export const setUserDetails = (user) => ({
  type: ActionTypes.SET_USER,
  payload: user,
});

export const setUserPanlessHoldings = (panlessHoldings) => ({
  type: ActionTypes.SET_USER_PANLESS_HOLDINGS,
  payload: panlessHoldings,
});

//------------- ONBOARDING -------------
export const setPanOnboardingStage = (panOnboardingStage) => ({
  type: ActionTypes.SET_PAN_ONBOARDING,
  payload: { panOnboardingStage: panOnboardingStage },
});

export const setShowOnboardingFlag = (shouldShowOnboarding) => ({
  type: ActionTypes.SET_SHOW_ONBOARDING,
  payload: shouldShowOnboarding,
});

export const setCurrentOnboardingStep = (currentStep) => ({
  type: ActionTypes.SET_CURRENT_ONBOARDING_STEP,
  payload: currentStep,
});

export const setCurrentAccountOnboardingStage = (currentStep) => ({
  type: ActionTypes.SET_CURRENT_ACCOUNT_ONBOARDING_STAGE,
  payload: currentStep,
});

export const setOnboardingDataForAddPan = (addPanData) => ({
  type: ActionTypes.SET_ONBOARDING_DATA_ADD_PAN,
  payload: addPanData,
});

export const setOnboardingKycDetails = (kycDetails) => ({
  type: ActionTypes.SET_ONBOARDING_DATA_KYC_DETAILS,
  payload: kycDetails,
});

export const setOnboardingKycVerificationStatus = (kycVerificationStatus) => ({
  type: ActionTypes.SET_ONBOARDING_DATA_KYC_VERIFICATION_STATUS,
  payload: kycVerificationStatus,
});

export const setOnboardingKycContactDetails = (kycContactDetails) => ({
  type: ActionTypes.SET_ONBOARDING_DATA_KYC_CONTACT,
  payload: kycContactDetails,
});

export const setKycDetails = (kycDetails) => ({
  type: ActionTypes.SET_ONBOARDING_KYC_DETAILS,
  payload: kycDetails,
});

export const setOnboardingFlowType = (flowType) => ({
  type: ActionTypes.SET_ONBOARDING_FLOW_TYPE,
  payload: flowType,
});

export const setOnboardingPan = (flowType) => ({
  type: ActionTypes.SET_ONBOARDING_PAN,
  payload: flowType,
});

export const clearOnboarding = () => ({
  type: ActionTypes.CLEAR_ONBOARDING_DATA,
  payload: {},
});

//---DASHBOARD----
export const setNews = (newsList) => ({
  type: ActionTypes.SET_NEWS,
  payload: newsList,
});

export const setBlog = (blogList) => ({
  type: ActionTypes.SET_BLOG,
  payload: blogList,
});

export const setTrendingFunds = (funds) => ({
  type: ActionTypes.SET_TRENDING_FUNDS,
  payload: funds,
});

export const setTopPicks = (funds) => ({
  type: ActionTypes.SET_TOP_PICKS,
  payload: funds,
});

//----PORTFOLIO----
export const setPortfolio = (portfolio) => ({
  type: ActionTypes.SET_PORTFOLIO,
  payload: portfolio,
});

export const clearPortfolio = () => ({
  type: ActionTypes.CLEAR_PORTFOLIO,
  payload: {},
});

export const setSips = (sips) => ({
  type: ActionTypes.SET_SIPS,
  payload: sips,
});

//--- PRICING PLANS -----
export const setPricingPlans = (pricingPlans) => ({
  type: ActionTypes.SET_PRICING_PLANS,
  payload: pricingPlans,
});

export const setCurrentPlan = (currentPlan) => ({
  type: ActionTypes.SET_CURRENT_PLAN,
  payload: currentPlan,
});

//---- WALLET ----
export const setWalletData = (walletData) => ({
  type: ActionTypes.SET_WALLET_DATA,
  payload: walletData,
});

//---- BROWSE ----
export const setBrowseFundsData = (browseFundsData) => ({
  type: ActionTypes.SET_BROWSE_FUNDS_DATA,
  payload: browseFundsData,
});

export const setBrowseCurrentFilters = (currentFilters) => ({
  type: ActionTypes.SET_BROWSE_CURRENT_FILTERS,
  payload: currentFilters,
});

export const setBrowseCurrentSortOption = (currentSortOption) => ({
  type: ActionTypes.SET_BROWSE_SORT_OPTION,
  payload: currentSortOption,
});

//---- CART ----
export const setCartCounts = (cartCounts) => ({
  type: ActionTypes.SET_CART_COUNTS,
  payload: cartCounts,
});

//---
export const resetStore = () => ({
  type: ActionTypes.RESET_STORE,
  payload: {},
});
//---- GOALS ----
export const setGoalsList = (goalsList) => ({
  type: ActionTypes.SET_GOALS_LIST,
  payload: goalsList,
});
export const setGoalSetupData = (goalSetupData) => ({
  type: ActionTypes.SET_GOAL_SETUP_DATA,
  payload: goalSetupData,
});
//---- BSE ----
export const setBse = (bse) => ({
  type: ActionTypes.SET_BSE,
  payload: bse,
});

//---token---
export const setToken = (token) => ({
  type: ActionTypes.SET_TOKEN,
  payload: token,
});

//---session handover token---
export const setSessionToken = (token) => ({
  type: ActionTypes.SET_SESSION_TOKEN,
  payload: token,
});

// SET BASKET DATA
export const setBaskets = (baskets) => ({
  type: ActionTypes.SET_BASKETS,
  payload: baskets,
});

//--Store public key for crypto--
export const setPublicKey = (key) => ({
  type: ActionTypes.SET_PUBLIC_KEY,
  payload: key,
});

//icici cart data
export const iciciCart = (cart) => ({
  type: ActionTypes.SET_ICICI_CART,
  payload: cart,
});

// SET Shopping Goals
export const setShoppingGoals = (goals) => ({
  type: ActionTypes.SET_SHOPPING_GOALS,
  payload: goals,
});

// SET amazon goal data
export const setAmazonGoalData = (goalData) => ({
  type: ActionTypes.SET_AMAZON_GOAL_DATA,
  payload: goalData,
});

//SE APP CONFIG
export const setAppConfig = (config) => ({
  type: ActionTypes.SET_APP_CONFIG,
  payload: config,
});

export const setRiskProfile = (key) => ({
  type: ActionTypes.SET_RISK_PROFILER,
  payload: key,
});

export const setUserState = (key) => ({
  type: ActionTypes.SET_USER_ESIGN_STATE,
  payload: key,
});

export const setTransactionState = (key) => ({
  type: ActionTypes.SET_USER_TRANSACTION_STATE,
  payload: key,
});

export const setNsdlPdfAnalyser = (key) => ({
  type: ActionTypes.SET_NSDL_PDF_ANALYSER,
  payload: key,
});

export const getObTPD = (key) => ({
  type: ActionTypes.GET_OROBONDS_TPD,
  payload: key,
});